/**
 * Create object with provided arrays of keys and values
 *
 * @param {String[]} keys
 * @param {Array} values
 */
function zipObject(keys, values) {
  return keys.reduce(function(object, currentValue, currentIndex) {
    object[currentValue] = values[currentIndex];

    return object;
  }, {});
}

/**
 * Create binding
 */
function createBinding(React) {
  const createElement = React.createElement || React.h;
  const Component = React.Component;

  /**
   * Subscribes a component to the store to re-render when specified store keys update
   *
   * @param {Object} Toystore instance
   * @param {React.Component} OriginalComponent - React component to subscribe/re-render
   * @param {String|Array|Object} mapping
   */
  function connect(store, OriginalComponent, mapping = null) {
    if (mapping === null) {
      throw new Error('No mapping provided');
    }

    if (typeof mapping === 'string') {
      mapping = [mapping];
    }

    function getPropKeys() {
      let propKeys = Object.keys(mapping);

      return propKeys;
    }

    function getStoreKeys() {
      let propKeys = getPropKeys();
      let storeKeys = propKeys.map((k) => mapping[k]);

      return storeKeys;
    }

    function getMappingForLocalPropNames() {
      let propKeys = getPropKeys();
      let storeKeys = getStoreKeys();

      let storeValues = storeKeys.map((k) => store.get(k));
      let storeValuesMapped = Object.keys(storeValues).map((k) => storeValues[k]);
      let valstoreMapping = zipObject(propKeys, storeValuesMapped);

      return valstoreMapping;
    }

    class ValstoreConnect extends Component {
      constructor() {
        super();

        this.state = {
          valstoreMapping: getMappingForLocalPropNames(),
        };

        this._isMounted = false;
        this._subscribeId;
        this.updateValstoreMapping = this.updateValstoreMapping.bind(this);
      }

      componentDidMount() {
        this._isMounted = true;
        this._subscribeId = store.subscribe(getStoreKeys(), this.updateValstoreMapping);
      }

      componentWillUnmount() {
        this._isMounted = false;
        store.unsubscribe(this._subscribeId);
      }

      updateValstoreMapping() {
        if (!this._isMounted) {
          return;
        }

        let updatedMapping = getMappingForLocalPropNames();

        this.setState({
          valstoreMapping: updatedMapping,
        });
      }

      render() {
        let props = Object.assign({}, this.props, this.state.valstoreMapping);

        return createElement(OriginalComponent, props, this.props.children);
      }
    }

    return ValstoreConnect;
  }

  // Public API
  return {
    connect,
  };
}

export default createBinding;
